/**
 * Get the value of a query parameter from the URL.
 * @param {string} key - The key of the query parameter.
 * @returns {string | null} - The value of the query parameter or null if not found.
 */
export const getQueryParam = (key: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
};

/**
 * Set a query parameter in the URL.
 * @param {string} key - The key of the query parameter.
 * @param {string} value - The value of the query parameter.
 */
export const setQueryParam = (key: string, value: string): void => {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.pushState({}, '', url.toString());
};

/**
 * Remove a query parameter from the URL.
 * @param {string} key - The key of the query parameter.
 */
export const removeQueryParam = (key: string): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete(key);
  window.history.pushState({}, '', url.toString());
};

/**
 * Get all query parameters from the URL as an object.
 * @returns {Record<string, string>} - An object containing all query parameters.
 */
export const getAllQueryParams = (): Record<string, string> => {
  const urlParams = new URLSearchParams(window.location.search);
  const params: Record<string, string> = {};
  urlParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
};
